export default {
  generateRandomKey () {
    const len = 5
    let text = ''
    const chars = 'abcdefghijklmnopqrstuvwxyz'

    for (let i = 0; i < len; i++) {
      text += chars.charAt(Math.floor(Math.random() * chars.length))
    }

    return text
  }

}
